import script from "./GoldPoint.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoldPoint.vue?vue&type=script&lang=ts&setup=true"

import "./GoldPoint.vue?vue&type=style&index=0&id=26f30e02&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f30e02"]])

export default __exports__